module.exports = __webpack_public_path__ + "assets/img/img42_1.c5ca81e5.png";